var _excluded = ["label", "error", "emptylabel", "floatinglabel", "floatinglabelbg", "className", "options", "condensed", "truncate", "labelclassname", "ariaLabel", "ariaDescribedby", "validationstate", "helperclassname", "ariaLive"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { forwardRef } from 'react';
import { Select } from '@cb/apricot-react';
var SelectControl = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    error = _ref.error,
    _ref$emptylabel = _ref.emptylabel,
    emptylabel = _ref$emptylabel === void 0 ? 'Choose...' : _ref$emptylabel,
    _ref$floatinglabel = _ref.floatinglabel,
    floatinglabel = _ref$floatinglabel === void 0 ? false : _ref$floatinglabel,
    _ref$floatinglabelbg = _ref.floatinglabelbg,
    floatinglabelbg = _ref$floatinglabelbg === void 0 ? false : _ref$floatinglabelbg,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    options = _ref.options,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? 50 : _ref$truncate,
    _ref$labelclassname = _ref.labelclassname,
    labelclassname = _ref$labelclassname === void 0 ? '' : _ref$labelclassname,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    _ref$ariaDescribedby = _ref.ariaDescribedby,
    ariaDescribedby = _ref$ariaDescribedby === void 0 ? '' : _ref$ariaDescribedby,
    validationstate = _ref.validationstate,
    _ref$helperclassname = _ref.helperclassname,
    helperclassname = _ref$helperclassname === void 0 ? '' : _ref$helperclassname,
    _ref$ariaLive = _ref.ariaLive,
    ariaLive = _ref$ariaLive === void 0 ? 'polite' : _ref$ariaLive,
    input = _objectWithoutProperties(_ref, _excluded);
  var validation = (validationstate !== null && validationstate !== void 0 ? validationstate : error) ? 'error' : undefined;
  return /*#__PURE__*/React.createElement(Select, {
    selectId: input.name,
    label: label,
    value: input.value,
    name: input.name,
    labelNoValue: emptylabel,
    values: options,
    condensed: condensed,
    required: input.required,
    disabled: input.disabled,
    onChange: input.onChange,
    validationMessageId: "errMessage-".concat(input.name),
    className: className,
    labelClassName: labelclassname,
    helperClassName: helperclassname,
    ariaLabel: ariaLabel,
    ariaDescribedby: ariaDescribedby,
    ariaLive: ariaLive,
    truncate: truncate,
    floating: floatinglabel,
    floatingBg: floatinglabelbg,
    validation: validation,
    validationMsg: error,
    ref: ref
  });
});
SelectControl.displayName = 'Select';
export default SelectControl;